<template>
  <LuJhu lu-jhu-type="ZongHeDanShuangLuJhu" />
</template>

<script>
import LuJhu from '@/components/desktop/common/trend/LuJhu'
export default {
  name: 'ZongHeDanShuang',
  components: {
    LuJhu
  }
}
</script>

